<template>
  <layout-basic>
    <v-container grid-list-md text-xs-center fluid="">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <v-card-text class="px-0">
              <img width="400" src="/static/marketplace.gif" alt="">
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
export default {
  components: {
    LayoutBasic
  }
};
</script>
